import SettingFrame from "../../../../../components/@settings/SettingFrame"
import UpdateTask from "../../../../../components/@schedulers/tasks/UpdateTask";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function TaskUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateTask 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       